var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessages3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.6673 10.4163V18.9163C36.6673 21.033 35.9673 22.8163 34.7173 24.0497C33.484 25.2997 31.7007 25.9996 29.584 25.9996V29.0163C29.584 30.1496 28.3173 30.833 27.384 30.1997L25.7673 29.133C25.9173 28.6163 25.984 28.0496 25.984 27.4496V20.6664C25.984 17.2664 23.7173 14.9997 20.3173 14.9997H9.00064C8.76731 14.9997 8.55065 15.0164 8.33398 15.033V10.4163C8.33398 6.16634 11.1673 3.33301 15.4173 3.33301H29.584C33.834 3.33301 36.6673 6.16634 36.6673 10.4163Z",
    fill: "#2C53F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.984 20.6667V27.45C25.984 28.05 25.9173 28.6166 25.7673 29.1333C25.1507 31.5833 23.1173 33.1167 20.3173 33.1167H15.784L10.7506 36.4667C10.0006 36.9833 9.00064 36.4333 9.00064 35.5333V33.1167C7.30064 33.1167 5.88399 32.55 4.90066 31.5667C3.90066 30.5667 3.33398 29.15 3.33398 27.45V20.6667C3.33398 17.5 5.30065 15.3167 8.33398 15.0334C8.55065 15.0167 8.76731 15 9.00064 15H20.3173C23.7173 15 25.984 17.2667 25.984 20.6667Z",
    fill: "#2C53F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages3);
export default __webpack_public_path__ + "static/media/messages-3.47425a0a47fbb73f6d3b74bcd0dee27b.svg";
export { ForwardRef as ReactComponent };